import {EventEmitter, Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {take} from 'rxjs/operators';
import {SnackBarService} from '@core/services/snack-bar.service';
import {IWorkflowCollectionState} from '@features/workflow/store/workflow.reducer';
import {Store} from '@ngrx/store';
import {
  SyncParticipantsCommand,
  SyncProjectEntityToCompanyCommand
} from '@features/dac6-reporter/commands/dac6-reporter.command';

@Injectable({
  providedIn: 'root',
})
export class ManageParticipantsCommandHandler  implements IPlatformCommandHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  activatedRoute: ActivatedRoute;
  magicLinkModelValueChanged: EventEmitter<any>;
  unSubscribe$ = new Subject<void>();
  constructor(
    private router: Router,
    private store: Store<IWorkflowCollectionState>,
    private fuseSplashScreenService: FuseSplashScreenService,
    private snackBarService: SnackBarService,
    protected commandService: CommandService
  ) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any) {
    const syncCommand = new SyncProjectEntityToCompanyCommand();
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(syncCommand).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.executeCommandToApi(command);
    });
    return true;
  }
  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }
}
